module.exports = __webpack_public_path__ + "static/img/no_item_image.30971c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_item_image.png
// module id = /kVz
// module chunks = 1